import { useEffect, useRef, useState } from 'react';
import { IconPlus } from '@tabler/icons-react';
import { SKORO_SEK, slovoMinut } from './obrabotkaUtils';
import { formatDuration } from './statusVocabulary';
import type { WorkplaceStateHook } from './useWorkplaceState';
import './okno-obrabotki.css';

/**
 * `s779` (обращение техподдержки №12, слова владельца 11.10.2026: «таймер прям на кнопке»). Обработка в
 * шапке: отсчёт идёт на самой кнопке «Завершить», рядом «+» — продлить на 1–5 минут. Отдельного места
 * таймер не занимает; высота шапки не растёт.
 */
export function ObrabotkaKnopki({ workplace, word }: { workplace: WorkplaceStateHook; word: (name: string) => string }) {
  const [menu, setMenu] = useState(false);
  const ref = useRef<HTMLSpanElement | null>(null);
  const ostalos = workplace.secondsLeft;
  const minuty = workplace.state?.obrabotka?.prodlit_minuty ?? [];

  useEffect(() => {
    if (!menu) return;
    const zakryt = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) setMenu(false);
    };
    document.addEventListener('mousedown', zakryt);

    return () => document.removeEventListener('mousedown', zakryt);
  }, [menu]);

  return (
    <span className="hdr-obrabotka" data-hdr="obrabotka" ref={ref}>
      <button className="hdr-btn hdr-primary hdr-obrabotka-zavershit" data-skoro={ostalos !== null && ostalos <= SKORO_SEK ? '1' : undefined}
        disabled={workplace.busy} onClick={() => void workplace.finish()}>
        {word('finish')}{ostalos !== null && <span className="hdr-obrabotka-chasy" data-hdr="obrabotka-chasy"> · {formatDuration(ostalos)}</span>}
      </button>
      {minuty.length > 0 && <button className="hdr-btn hdr-icon" disabled={workplace.busy} aria-expanded={menu}
        aria-label={word('extend')} title={word('extend')} onClick={() => setMenu(!menu)}><IconPlus size={20} /></button>}
      {menu && <div className="hdr-menu hdr-obrabotka-menu" role="menu" aria-label={word('extend')}>
        {minuty.map((n) => <button key={n} role="menuitem" disabled={workplace.busy}
          onClick={() => { setMenu(false); void workplace.extend(n); }}>{slovoMinut(word, n)}</button>)}
      </div>}
    </span>
  );
}
